<template>
  <div>
    <h5 class="text-primary mt-4">CAMBIO / INCORPORACIÓN DE MATRÍCULA</h5>
    <b-row class="mt-3">
      <b-col>
        <b-form-group label="Seleccione tipo de gestión:">
          <b-form-radio-group
            id="btn-radios-2"
            v-model="tipoGestion"
            :options="tiposGestion"
            buttons
            button-variant="outline-primary"
            size="md"
            name="radio-btn-outline"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div v-if="tipoGestion != null">
      <b-row class="mt-2">
        <b-col sm="2">
          <b-form-checkbox
            class="mt-2"
            v-model="chk.provincial"
            name="check-button"
            switch
          >Provincial</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            :disabled="!chk.provincial"
            type="text"
            placeholder="Ingrese Matrícula"
            v-model="matricula.provincial"
            @blur="$v.matricula.provincial.$touch"
            :state="$v.matricula.provincial.$dirty && chk.provincial ? !$v.matricula.provincial.$error : null"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="2">
          <b-form-checkbox class="mt-2" v-model="chk.nacional" name="check-button" switch>Nacional</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            :disabled="!chk.nacional"
            type="text"
            placeholder="Ingrese Matrícula"
            v-model="matricula.nacional"
            @blur="$v.matricula.nacional.$touch"
            :state="$v.matricula.nacional.$dirty && chk.nacional ? !$v.matricula.nacional.$error : null"
          ></b-input>
        </b-col>
      </b-row>
    </div>

    <!-- submit controls-->
    <div class="submit-footer">
      <b-row>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >

            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>

            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
export default {
  props: ['nroPoliza', 'asegurado'],
  data() {
    return {
      sending: false,
      tipoGestion: null,
      tiposGestion: [
        {
          text: 'Cambio',
          value: 'cambio'
        },
        {
          text: 'Incorporación',
          value: 'incorporacion'
        }
      ],
      chk: {
        provincial: false,
        nacional: false
      },
      matricula: {
        provincial: '',
        nacional: ''
      }
    };
  },
  validations: {
    matricula: {
      provincial: {
        required: requiredIf(function() {
          return this.chk.provincial;
        })
      },
      nacional: {
        required: requiredIf(function() {
          return this.chk.nacional;
        })
      }
    }
  },
  methods: {
    submit: async function() {
      this.$v.matricula.$touch();

      if (this.$v.matricula.$invalid) {
        return null;
      }

      if (!this.tipoGestion) {
        this.$toast.error('Seleccione el tipo de gestión');
        return null;
      }

      if (!Object.values(this.chk).some(c => c)) {
        this.$toast.error('Debe ingresar al menos una matrícula.');
        return null;
      }

      this.sending = true;

      await this.$api.post(`endoso/solicitud/cambio-matricula/${this.$route.params.cod_tomador}`, {
        tipoGestion: this.tipoGestion,
        poliza: this.nroPoliza,
        asegurado: this.asegurado.text,
        pas: {
          nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
          codigo: this.$store.state.auth.cod_agente,
          email: this.$store.state.auth.email
        },
        matricula: this.matricula
      }).then(() => {
        this.$toast.success(`Solicitud de endoso por ${this.tipoGestion} de matrícula enviada exitosamente.`);
      }).catch(err => {
        //console.log(err.response);
        this.$toast.error(`Ocurrión un error al enviar la solicitud de endoso por ${this.tipoGestion} de matrícula`);
      })

      this.sending = false;
    }
  }
};
</script>
